import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TT_LIB_ENV_CONFIG } from '@tt-lib/tt-lib-env.config.token';
import { AppEnvironmentConfig } from '@tt-lib/interfaces/app-environment-config';

@Injectable({
  providedIn: 'root'
})
export class CsrfService {

  private _appEnvironmentConfig: AppEnvironmentConfig = inject(TT_LIB_ENV_CONFIG);

  constructor(
    private http: HttpClient,
  ) {
  }

  // ? Move this call to the application (not tt-lib?)
  fetchToken() {
    const url = this._appEnvironmentConfig.BASEURL + '/tmv-services/security/csrf';
    const httpOptions = {
      headers: {
        'content-type': 'text/plain',
        'Cache-control': 'no-store',
      },
      responseType: 'text' as 'json',
      withCredentials: true
    };
    return this.http.get<string>(url, httpOptions);
  }
}
